import { createAsyncThunk } from "@reduxjs/toolkit";
import { type DeliveryReport } from "../../../domain/entities/supervisor-delivery";
import { type SupervisorDeliveryDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listReports = createAsyncThunk<
  DeliveryReport[],
  string,
  { dispatch: SupervisorDeliveryDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_REPORTS, async (requestId, { extra }) => {
  return await extra.supervisorDeliveryRepo.listReports(requestId);
});
